"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.panicTextMessageEventDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const FirestoreTimestamp_1 = require("./firebase/FirestoreTimestamp");
function panicTextMessageEventDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        contactId: (0, deserializeString_1.deserializeString)(object.contactId),
        contactName: (0, deserializeString_1.deserializeString)(object.contactName),
        contactPhone: (0, deserializeString_1.deserializeString)(object.contactPhone),
        errorMessage: (0, unwrap_1.default)(object.errorMessage, deserializeString_1.deserializeString),
        panicEventId: (0, deserializeString_1.deserializeString)(object.panicEventId),
        timestamp: (0, FirestoreTimestamp_1.firestoreTimestampDeserialize)(object.timestamp),
    };
}
exports.panicTextMessageEventDeserialize = panicTextMessageEventDeserialize;
